import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { AuthService } from './auth.service';
import { RouteNames } from '../route.name';
import { MenuService } from '../providers.module/menu.service';

@Injectable()
export class AuthGuard  {

    constructor(
        private readonly authService: AuthService,
        private readonly router: Router,
        private readonly menuService: MenuService,
    ) {
        console.debug('Auth-Guard eingebunden. isLoggedIn:' + authService.isLoggedIn(), this);
    }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
        const url: string = state.url;
        const menuPoint = this.menuService.findMenupointOrNull(url);
        const rights = this.authService.getRole();
        const accessible = this.menuService.isAccessible(menuPoint, rights);

        if (this.authService.isLoggedIn() && !accessible) {
            const alternative = this.menuService.findAlternativeForOrNull(menuPoint, rights);

            if (alternative) {
                this.router.navigate(['/' + alternative.targetUri]);
            }

            return false;
        }

        return this.checkLogin(url);
    }

    canActivateChild(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
        return this.canActivate(route, state);
    }

    gotoLogin(): void {
        this.authService.logout();
        this.router.navigate([RouteNames.KREDIT_PORTAL_COCKPIT]);
    }

    checkLogin(url: string): boolean {
        console.debug('Prüfe Login', url, this);

        if (this.authService.isLoggedIn()) {
            return true;
        }

        console.debug('Navigiere zur Loginseite', this);
        // Navigate to the login page with extras
        this.gotoLogin();

        return false;
    }

}
